module.exports = __webpack_public_path__ + "static/media/luotettava-kumppani.1243a437.png";